import {DimensionValue, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {
  alto,
  blueHaze,
  daisyBush,
  denim,
  disco,
  eden,
  fuchsiaBlue,
  gallery,
  genoa,
  graniteGray,
  java,
  magenta,
  malibu,
  orange,
  perfume,
  puertoRico,
  redViolet,
  toryBlue,
} from '/theme/color/secondary.color';

const VIEWPORT_HEIGHT_WITHOUT_TAB_BAR: DimensionValue =
  `calc(100vh - ${TAB_BAR_HEIGH}px)` as DimensionValue;

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center' as const,
    backgroundColor: white,
    minHeight: 0,
    height: '100%' as const,
    maxHeight: '100%' as const,
  },
  scrollView: {
    flex: 1,
    minHeight: 0,
    height: '100%' as const,
    maxHeight: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    overflow: 'scroll' as const,
  },
  scrollContent: {
    flexGrow: 1,
  },
  contentContainer: {
    alignItems: 'center',
  },
  datePicker: {
    marginTop: indent * 1.2,
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: indent * 0.8,
    paddingVertical: indent * 0.4,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: alto,
  },
  chevronDown: {
    marginLeft: indent * 0.4,
    fontSize: 16,
  },
  totalBonusContainer: {
    marginTop: indent * 1.2,
  },
  totalBonusTitle: {
    color: graniteGray,
  },
  totalBonus: {
    marginTop: indent * 0.4,
  },
  splitter: {
    marginTop: indent * 1.2,
    borderColor: gallery,
    borderBottomWidth: 1,
  },
  title: {
    fontSize: 20,
  },
  loading: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  totalBonusesContainer: {
    paddingBottom: indent,
  },
  emptyScreen: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '60%',
  },
});

export const styleMutation = ({index, colorScale}: any) => ({
  style: {
    fill: colorScale[index],
    stroke: 'transparent',
  },
});

export const colorScaleByBonusId = {
  5: toryBlue,
  6: denim,
  7: malibu,
  8: eden,
  9: genoa,
  10: puertoRico,
  11: daisyBush,
  12: fuchsiaBlue,
  13: perfume,
  14: blueHaze,
  16: magenta,
  28: java,
  29: orange,
  1021: redViolet,
  1022: disco,
};
